import { apiInstance } from "./apiInstance";
import { LOGIN_TOKEN } from "./AuthApi";
import { setToken } from "./ClientHelper";
import localStoreUtil from "./localstore.util";

export const ApiPostNoAuth = async (type, endUrl, userData) => {
  let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
  if (login_token) {
    await setToken(login_token);
  }
  return new Promise((resolve, reject) => {
    apiInstance
      .post(type + endUrl, userData)
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        if (
          error?.hasOwnProperty("response") &&
          error?.response?.hasOwnProperty("data") &&
          error?.response?.data?.hasOwnProperty("error") &&
          error?.response?.data?.error
        ) {
          reject(error?.response?.data);
        } else {

          reject(error?.response);
        }
      });
  });
};

export const ApiGetNoAuth = async (type, endUrl, body) => {
  let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
  if (login_token) {
    await setToken(login_token);
  }
  return new Promise((resolve, reject) => {
    apiInstance
      .get(type + endUrl)
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        if (
          error?.hasOwnProperty("response") &&
          error?.response?.hasOwnProperty("data") &&
          error?.response?.data?.hasOwnProperty("error") &&
          error?.response?.data?.error
        ) {
          reject(error?.response?.data);
        } else {
          reject(error?.response);
        }
      });
  });
};

export const ApiDeleteNoAuth = async (type, endUrl) => {
  let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
  if (login_token) {
    await setToken(login_token);
  }
  return new Promise((resolve, reject) => {
    apiInstance
      .delete(type + endUrl)
      .then((responseJson) => {
        resolve(responseJson);
      })
      .catch((error) => {
        if (
          error?.hasOwnProperty("response") &&
          error?.response?.hasOwnProperty("data") &&
          error?.response?.data?.hasOwnProperty("error") &&
          error?.response?.data?.error
        ) {
          reject(error?.response?.data);
        } else {
          reject(error?.response);
        }
      });
  });
};

export const CommonRequest =
  (url, data, type = "get", params, extraData = {}) =>
    async () => {
      try {
        const reqObj = { url: url, method: type, params: params, data: data, ...extraData, };
        const res = await apiInstance.request(reqObj);
        if (reqObj?.responseType === "blob") {
          return res;
        }
        if (res.data.code === 0) {
          throw res.data.message;
        }

        return res.data;
      } catch (err) {
        throw new Error(
          err instanceof Object ? err.message : err
        );
      }
    };

export const CreateRoute = (type, endUrl) => {
  return `${type}${endUrl}`;
};


